const SECTION_ORDER = [
  { key: "caeUsers", label: "CAE Users" },
  { key: "organizations", label: "Organizations" },
  { key: "universities", label: "Universities" },
  { key: "programs", label: "Programs" },
  { key: "brochures", label: "Brochures" },
  { key: "processSheets", label: "Process Sheets" },
  { key: "applicants", label: "Applicants" },
  { key: "visaAccounts", label: "Visa Accounts" },
  { key: "chats", label: "Chats" },
  { key: "studentChats", label: "Student Chats" },
  { key: "studentNotes", label: "Student Notes" },
  { key: "degrees", label: "Degrees" },
  { key: "countryStates", label: "Country States" },
  { key: "contractTypes", label: "Contract Types" },
  { key: "folders", label: "Folders" },
  { key: "files", label: "Files" },
  { key: "notifications", label: "Notifications" },
];

export const buildSearchSections = (response) => {
  const payload = response?.data || response || {};

  return SECTION_ORDER.reduce((acc, section) => {
    const items = Array.isArray(payload[section.key]) ? payload[section.key] : [];

    if (items.length > 0) {
      acc.push({
        key: section.key,
        label: section.label,
        items,
      });
    }

    return acc;
  }, []);
};
